import api from './api'

export interface LeadRule {
  id: number
  user_id: number
  name: string
  description: string | null
  criteria: string
  min_confidence: number
  is_active: boolean
  created_at: string
  updated_at: string | null
  leads_count: number
}

export interface LeadRuleCreate {
  name: string
  description?: string
  criteria: string
  min_confidence?: number
}

export interface LeadRuleUpdate {
  name?: string
  description?: string
  criteria?: string
  min_confidence?: number
  is_active?: boolean
}

export const leadRulesService = {
  async getRules(): Promise<LeadRule[]> {
    const response = await api.get<LeadRule[]>('/lead-rules')
    return response.data
  },

  async getRule(ruleId: number): Promise<LeadRule> {
    const response = await api.get<LeadRule>(`/lead-rules/${ruleId}`)
    return response.data
  },

  async createRule(data: LeadRuleCreate): Promise<LeadRule> {
    const response = await api.post<LeadRule>('/lead-rules', data)
    return response.data
  },

  async updateRule(ruleId: number, data: LeadRuleUpdate): Promise<LeadRule> {
    const response = await api.patch<LeadRule>(`/lead-rules/${ruleId}`, data)
    return response.data
  },

  async deleteRule(ruleId: number): Promise<void> {
    await api.delete(`/lead-rules/${ruleId}`)
  },
}
